import {Button} from 'shells/button/button';
import {Stack} from 'shells/layout/stack/stack';
import {FooterBar} from 'shells/modal/footer-bar';

import {EmailSettingsSetupBreadcrumbs} from './email-settings-setup-breadcrumbs';
import {EmailSetupStep} from './types';

interface Props {
    currentStep: EmailSetupStep;
    setCurrentStep: (step: EmailSetupStep) => void;
    emailAddress: string;
    displayName: string;
    isLoading: boolean;
    onNext: () => void;
    onSave: () => void | Promise<void>;
}

export function EmailSettingsSetupFooter(props: Props) {
    return (
        <div className='border-top px-16'>
            <FooterBar
                left={
                    <EmailSettingsSetupBreadcrumbs
                        currentStep={props.currentStep}
                        setCurrentStep={props.setCurrentStep}
                    />
                }
                right={
                    <Stack spacing={16} isHorizontal={true}>
                        {props.currentStep === EmailSetupStep.NAME_INBOX && (
                            <Button
                                variant='secondary'
                                size='big'
                                onClick={() => props.setCurrentStep(EmailSetupStep.ADD_EMAIL)}
                            >
                                Back
                            </Button>
                        )}
                        <Button
                            variant={
                                props.currentStep === EmailSetupStep.NAME_INBOX ? 'save' : 'primary'
                            }
                            size='big'
                            disabled={
                                props.currentStep === EmailSetupStep.ADD_EMAIL
                                    ? !props.emailAddress.trim().length
                                    : !props.displayName.trim().length || props.isLoading
                            }
                            onClick={
                                props.currentStep === EmailSetupStep.ADD_EMAIL
                                    ? props.onNext
                                    : props.onSave
                            }
                        >
                            {props.currentStep === EmailSetupStep.ADD_EMAIL
                                ? 'Next'
                                : 'Continue configuration'}
                        </Button>
                    </Stack>
                }
            />
        </div>
    );
}
